<div class="container" [ngSwitch]="textData.type" [ngClass]="class">
    <div *ngSwitchCase="'bulleted'">
        <ng-container *ngTemplateOutlet="bullet"></ng-container>
    </div>

    <div *ngSwitchCase="'icon'">
        <ng-container *ngTemplateOutlet="icon"></ng-container>
    </div>

    <div *ngSwitchDefault>
        <p *ngFor="let paragraph of textData.items" class="plain-text" [innerHTML]="paragraph.content | safeHtml"></p>
    </div>
</div>

<ng-template #bullet>
    <div class="bullet-container dynamic-html">
        <h2 *ngIf="textData.title" class="section-title" [innerHTML]="textData.title | safeHtml"></h2>
        <h3 *ngIf="textData.subtitle" class="section-subtitle" [innerHTML]="textData.subtitle | safeHtml"></h3>
        <ul>
            <li *ngFor="let paragraph of textData.items">
                <a href="{{paragraph.href}}" *ngIf="paragraph.href; else content" [innerHTML]="paragraph.content | safeHtml"></a>
                <ng-template #content>
                    <span [innerHTML]="paragraph.content | safeHtml"></span>
                </ng-template>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #icon>
    <div class="icon-container">
        <h2 *ngIf="textData.title" class="section-title" [innerHTML]="textData.title | safeHtml"></h2>
        <h3 *ngIf="textData.subtitle" class="section-subtitle" [innerHTML]="textData.subtitle | safeHtml"></h3>
        <ul>
            <li *ngFor="let paragraph of textData.items">
                <div class="title-section">
                    <finder-font-icon [hexValue]="paragraph.icon" size="m"></finder-font-icon>
                    <span class="section-subtitle" *ngIf="paragraph.title" [innerHTML]="paragraph.title | safeHtml"></span>
                </div>
                <div *ngIf="paragraph.content" class="text-section" [innerHTML]="paragraph.content | safeHtml"></div>
            </li>
        </ul>
    </div>
</ng-template>
